
<div class="pr-1">
    <c-card-iterator
        :items             = "filteredUnits"
        :label             = "title"
        :loading           = "loading"
        :title-prefix      = "true"
        :item-gap          = "0"
        :filter-height     = "user ? 330 : 286"
        :min-height        = "120"
        key-field          = "row"
        :zoom              = "false"
        :left-arrow        = "false"
        :refresh-on-filter = "false"
        :show-count        = "false"
        :enable-search     = "false"
        scroller-type      = "default"
        header-color       = "primary"
        ref                = "iterator"
    >
        <template v-slot:toolbar>
            <c-toolbar-button
                v-if     = "filteredUnits && filteredUnits.length"
                class    = "mr-3"
                style    = "margin-top: -2px;"
                icon     = "mdi-arrow-expand-vertical"
                size     = "22"
                color    = "white"
                tooltip  = "Alle Adressen aufklappen"
                @click   = "onExpandAll"
            />

            <c-toolbar-button
                v-if     = "filteredUnits && filteredUnits.length"
                class    = "mr-3"
                style    = "margin-top: -2px;"
                icon     = "mdi-arrow-collapse-vertical"
                size     = "22"
                color    = "white"
                tooltip  = "Alle Adressen zusammenklappen"
                @click   = "onCollapseAll"
            />

            <c-toolbar-button
                v-if     = "filteredUnits && filteredUnits.length"
                class    = "mr-3"
                style    = "margin-top: -2px;"
                icon     = "mdi-refresh"
                size     = "22"
                color    = "white"
                :tooltip = "$t('disposition.order.refresh')"
                @click   = "onRefresh"
            />
        </template>

        <template v-slot:filter>
            <div class="w-100 v-flex">
                <div class = "lm-border pa-3 pb-6 w-50 mr-1" v-if="!order">
                    <v-row class="no-frame">
                        <v-col class="no-frame col-12">
                            <div class="pb-1">
                                <v-text-field
                                    v-model        = "filter.order"
                                    label          = "Auftrag"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                    :clearable     = "true"
                                    @input         = "onFilter"
                                    hide-details
                                />
                            </div>
                        </v-col>
                    </v-row>
                </div>
                <div class="lm-border pa-3 pb-4" :class="!order ? 'w-50 ml-1' : 'w-100'">
                    <v-row class="no-frame">
                        <v-col class="no-frame col-6 pr-2">
                            <v-text-field
                                v-model        = "filter.location"
                                label          = "Adresse"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                @input         = "onFilter"
                                :clearable     = "true"
                                hide-details
                            />
                        </v-col>

                        <v-col class="no-frame col-6 pl-2 pr-2">
                            <v-text-field
                                v-model        = "filter.unit"
                                label          = "Anlage"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                @input         = "onFilter"
                                :clearable     = "true"
                                hide-details
                            />
                        </v-col>
                    </v-row>
                    <v-row class="no-frame mt-3">
                        <v-col class="no-frame col-3 pr-2">
                            <v-text-field
                                label          = "von PLZ"
                                v-model        = "filter.zip.from"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                :clearable     = "true"
                                @input         = "onFilter"
                                hide-details
                            />
                        </v-col>
                        <v-col class="no-frame col-3 pl-2 pr-2">
                            <v-text-field
                                label          = "bis PLZ"
                                v-model        = "filter.zip.to"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                :clearable     = "true"
                                @input         = "onFilter"
                                hide-details
                            />
                        </v-col>
                    </v-row>

                    <v-row class="no-frame mt-3">
                        <v-col class="no-frame">
                            <v-switch
                                label   = "geplante Begehungen (ohne Gutachter)"
                                v-model = "filter.created"
                                class   = "mt-4"
                                :ripple = "false"
                                @change = "onFilter"
                                hide-details
                                dense
                            >
                            </v-switch>
                        </v-col>
                    </v-row>

                    <v-row class="no-frame">
                        <v-col class="no-frame">
                            <v-switch
                                label   = "zugeordnete Begehungen (mit Gutachter)"
                                v-model = "filter.assigned"
                                class   = "mt-4"
                                :ripple = "false"
                                @change = "onFilter"
                                hide-details
                                dense
                            >
                            </v-switch>
                        </v-col>
                    </v-row>

                    <v-row class="no-frame">
                        <v-col class="no-frame">
                            <v-switch
                                label   = "Abgeschlossene Begehungen"
                                v-model = "filter.closed"
                                class   = "mt-4"
                                :ripple = "false"
                                @change = "onFilter"
                                hide-details
                                dense
                            >
                            </v-switch>
                        </v-col>
                    </v-row>

                    <v-row class="no-frame">
                        <v-col class="no-frame">
                            <v-switch
                                :label  = "$t('disposition.inspection.deviceType.conflict.filter')"
                                v-model = "filter.conflict"
                                class   = "mt-4"
                                :ripple = "false"
                                @change = "onFilter"
                                hide-details
                                dense
                            >
                            </v-switch>
                        </v-col>
                    </v-row>

                    <v-row class="no-frame" v-if="user">
                        <v-col class="no-frame col-12">
                            <v-switch
                                label   = "Begehungen des gewählten Gutachter"
                                v-model = "filter.user"
                                class   = "mt-4"
                                :ripple = "false"
                                @change = "onFilter"
                                hide-details
                                dense
                            >
                            </v-switch>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </template>

        <template v-slot:card="{ item }">
            <p-disposition-location-card
                :order         = "order"
                :location      = "item.data"
                :assignments   = "assignments"
                :selectable    = "isSelectable(item.data)"
                :user          = "user"
                :show-order    = "!order"
                :selected      = "isSelected(item)"
                :map-selected  = "mapSelected && mapSelected.id === item.data.id"
                :assign-on     = "assignOn"
                :dispatch-on   = "dispatchOn"
                @site          = "onSite"
                @assign        = "onAssign"
                @assign-all    = "onAssignAll"
                @deselect      = "onDissolve"
                @dissolve-all  = "onDissolveAll"
                @dispatch      = "onDispatch"
                @dispatch-all  = "onDispatchAll"
                @release       = "onRelease"
                @release-all   = "onReleaseAll"
                @selected      = "onSelected"
                @expand        = "onExpand"
                @collapse      = "onCollapse"
                @locate        = "onLocate"
            />
        </template>
    </c-card-iterator>
</div>
